import React from 'react';

function DownloadSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <rect x="-6.10352e-05" width="20" height="20" rx="4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99994 4.5C10.5522 4.5 10.9999 4.94772 10.9999 5.5V9.08579L12.2928 7.79289C12.6834 7.40237 13.3165 7.40237 13.707 7.79289C14.0976 8.18342 14.0976 8.81658 13.707 9.20711L10.707 12.2071C10.3165 12.5976 9.68336 12.5976 9.29283 12.2071L6.29283 9.20711C5.90231 8.81658 5.90231 8.18342 6.29283 7.79289C6.68336 7.40237 7.31652 7.40237 7.70705 7.79289L8.99994 9.08579V5.5C8.99994 4.94772 9.44765 4.5 9.99994 4.5Z"
        fill="#969FA8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99994 14.5C4.99994 13.9477 5.44765 13.5 5.99994 13.5H13.9999C14.5522 13.5 14.9999 13.9477 14.9999 14.5C14.9999 15.0523 14.5522 15.5 13.9999 15.5H5.99994C5.44765 15.5 4.99994 15.0523 4.99994 14.5Z"
        fill="#969FA8"
      />
    </svg>
  );
}

export default DownloadSVG;
